import { render, staticRenderFns } from "./skinpeeler.vue?vue&type=template&id=07cba882&scoped=true"
import script from "./skinpeeler.vue?vue&type=script&lang=js"
export * from "./skinpeeler.vue?vue&type=script&lang=js"
import style0 from "./skinpeeler.vue?vue&type=style&index=0&id=07cba882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cba882",
  null
  
)

export default component.exports